import React from 'react';

// Toast notification component
export default function ToastNotification({ 
  toastMessage, 
  showToast, 
  style: customStyle 
}: { 
  toastMessage: string | null; 
  showToast: boolean;
  style?: React.CSSProperties;
}) {
  if (!toastMessage) return null;

  const defaultStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    right: '72px', // Position to the left of the X button
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '11.4px',
    fontWeight: 'bold',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 1000,
    opacity: showToast ? 1 : 0,
    transition: 'all 0.3s ease',
    transform: showToast ? 'translateY(-50%) translateX(0)' : 'translateY(-50%) translateX(20px)',
    // maxWidth: '200px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  // Merge custom styles with default styles
  const mergedStyle = { ...defaultStyle, ...customStyle };

  return (
    <div style={mergedStyle}>
      {toastMessage}
    </div>
  );
};
